/**
 * Handles Cryptocurrency promo
 */
import {Application} from "../application/application";
import webAPI from "../api/web-api-2";
import {JoinedRoomData} from "../chatserver/sx-server";
import logging from "../utils/log";

export class CryptoPromo
{
	private TAG = "Crypto";
	private checkTimer: number;

	private checkInterval = 300 * 1000;
	private firstCheckWait = 15 * 1000;
	private isActive: boolean;

	constructor(private app : Application)
	{
		logging.log(this.TAG, "Initialized");

		this.app.view.topupPanel.event.on("topup_attempt", () => {
			logging.log(this.TAG, "After topup...");
			this.queryState("afterTopup");
		});

		this.app.event.on("visible", (v) => {
			this.active(v);
		})
	}

	private active(isActive : boolean)
	{
		if (isActive == this.isActive) {
			return;
		}

		this.isActive = isActive;


		if (isActive) {
			logging.log(this.TAG, "Activated. Will do the first check soon...");

			this.checkTimer = setTimeout(
				() =>
				{
					this.queryState("normal");

					this.checkTimer = setInterval(
						() => this.queryState("normal"),
						this.checkInterval
					);

				}, this.firstCheckWait
			);
		}
		else
		{
			logging.log(this.TAG, "Deactivated");
			clearInterval(this.checkTimer);
		}
	}

	private async getCurrentPromo(check : "normal" | "afterTopup")
	{
		logging.log(this.TAG, "Query current promo...");

		return webAPI.post("member/cryptoPromo/getCurrent", {check})
			.then((r : any) => {
				logging.log(this.TAG, "Query result is", r);
				if (r.success) {
					return r.promo;
				} else {
					return Promise.reject(null);
				}
			});
	}

	private async queryState(check : "normal" | "afterTopup")
	{
		logging.log(this.TAG, "Querying state for", check);
		const promo = await this.getCurrentPromo(check);
		logging.log(this.TAG, "Current promo is", promo);

		if (promo) {
			this.showPromo();
		}
	}

	private showPromo()
	{
		logging.log(this.TAG, "Showing promo");

		const title = this.app.translator.t("promo_notification_crypto_title");
		const link = this.app.translator.t("promo_notification_crypto_link");
		const desc = this.app.translator.t("promo_notification_crypto_desc");

		const $notif = $("<div />")
			.append(
				$("<div class='sxccsn-title' />").text(title),
				$("<p />")
					.append(desc)
					.append(" ")
					.append($("<a href='#' />").text(link))
			);

		this.app.view.streamNotificationManager.add(
			$notif,
			"big",
			"crypto-promo",
			30 * 1000,
			() => {
				this.app.view.topupPanel.show(true, "cryptocurrency");
			});
	}
}
